import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.number.constructor.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import filter from 'lodash/filter';
import { mapGetters } from 'vuex';
import { buildCategoryNextLink, buildCategoryPrevLink, buildCategoryCanonical, buildCategoryAlternates } from '~/helpers/seo-helpers';
export default {
  name: 'CategorySeo',
  props: {
    seo: {
      type: Object,
      required: true
    },
    hreflang: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    total: {
      type: Number,
      required: true
    },
    page: {
      type: Number,
      required: true
    },
    hash: {
      type: String,
      required: true
    },
    path: {
      type: String,
      required: true
    },
    partialPath: {
      type: String,
      required: true
    },
    hasOpenFacets: {
      type: Boolean,
      required: false
    }
  },
  computed: _objectSpread(_objectSpread({}, mapGetters({
    locales: 'i18n/locales',
    locale: 'i18n/locale',
    baseURL: 'request/baseURL'
  })), {}, {
    facet: function facet() {
      return this.seo.facet_opened ? this.seo.facet_opened : '';
    }
  }),
  head: function head() {
    return {
      title: "".concat(this.title, " | Maisons du Monde"),
      link: filter([buildCategoryPrevLink(this.locale, this.baseURL, this.partialPath, this.page, this.facet), buildCategoryCanonical(this.locale, this.baseURL, this.partialPath, this.page, this.facet), buildCategoryNextLink(this.locale, this.baseURL, this.partialPath, this.total, this.page, this.facet)].concat(_toConsumableArray(buildCategoryAlternates(this.baseURL, this.seo.alternate, this.hash, this.page, this.facet, this.hreflang, this.hasOpenFacets))), function (entry) {
        return entry !== null;
      }),
      meta: [this.seo.is_indexed ? {} : {
        hid: 'robots',
        name: 'robots',
        content: 'noindex'
      }, {
        name: 'description',
        content: this.seo.meta_description
      }]
    };
  },
  render: function render(h) {
    return h(null);
  }
};